import { testIds } from '../testConfig.utils';

export const QA_MATCH_HEADER_ON_SCROLL = {
  ...testIds('MATCH_HEADER_ON_SCROLL', {}),
};

export const QA_PROFILE_HERO = {
  ...testIds('QA_PROFILE_HERO', {}),
};

export const QA_SPONSOR_CARD = {
  ...testIds('SPONSOR_CARD', {}),
};
